import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GridView from "../components/grid-view/GridView";
import CollectionService from "../services/CollectionService";
import Loader from "../components/loader/Loader";

function ProductsPage() {
    const params = useParams();
    const service = new CollectionService();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        params.categoryId && getData(params.categoryId);
        return (() => {
            setData();
        })
        // eslint-disable-next-line
    }, [])

    const getData = async (categoryId) => {
        //const response = await service.getProducts();
        const response = await service.getProductsByCategory(categoryId);
        setData(response?.data);
        setLoading(false);
    }

    return (
        <div className="page products-page">
            <Loader loading={loading} />
            {data?.length > 0 && <GridView data={data} preroute={'/item'} type={'product'} />}
            <div className="divider"></div>
        </div>
    );
}

export default ProductsPage;
